<template>
  <v-stepper vertical v-model="step" flat>
    <v-stepper-step step="1" :complete="step > 1">
      Dados Pessoais
      <small class="mt-1"
        >Dados de identificação, contato, escolaridade e outras informações
        adicionais</small
      >
    </v-stepper-step>
    <v-stepper-content step="1" :class="isMobile() ? 'pl-2' : ''">
      <dados-pessoais />
    </v-stepper-content>

    <v-stepper-step step="2" :complete="step > 2">
      Áreas de Interesse
      <small class="mt-1"
        >Selecione as áreas de interesse nas quais deseja se candidatar</small
      >
    </v-stepper-step>
    <v-stepper-content step="2" :class="isMobile() ? 'pl-2' : ''">
      <areas-interesse />
    </v-stepper-content>

    <v-stepper-step step="3" :complete="step > 3">
      Experiências Profissionais
      <small class="mt-1"
        >Informe quais foram suas experiências profissionais anteriores</small
      >
    </v-stepper-step>
    <v-stepper-content step="3" :class="isMobile() ? 'pt-0 pl-2' : ''">
      <experiencias-profissionais />
    </v-stepper-content>

    <!--<v-stepper-step step="4">
              Documentação
              <small class="mt-1"
                >Complemento dos dados e envio da documentação</small
              >
            </v-stepper-step>
            <v-stepper-content step="4">
              <envio-documentacao />
              <btn-voltar-passo />
            </v-stepper-content> -->
  </v-stepper>
</template>

<script>
import { mapState } from "vuex";
import AreasInteresse from "./AreasInteresse.vue";
import DadosPessoais from "./DadosPessoais.vue";
import ExperienciasProfissionais from "./ExperienciasProfissionais.vue";

export default {
  components: {
    DadosPessoais,
    AreasInteresse,
    ExperienciasProfissionais,
  },
  computed: { ...mapState(["step", "candidato"]) },
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>
